import axios from "axios";
const baseURL = "http://a.matripe.com.cn"; // 正式环境本地
axios.defaults.withCredentials = true; //添加这行代码
// console.log(axios);
const service = axios.create({
  // baseURL: "/api_prod", // url = base url + request url  测试
  baseURL: baseURL, //  baseURL: "/api", // url = base url + request url 正式
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  crossDomain: true,
});
export default service;
